/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Address = {
  properties: {
    street: {
      type: 'string',
      isRequired: true,
    },
    number: {
      type: 'string',
      isRequired: true,
    },
    complement: {
      type: 'string',
    },
    neighborhood: {
      type: 'string',
      isRequired: true,
    },
    zipCode: {
      type: 'string',
      isRequired: true,
    },
    city: {
      type: 'string',
      isRequired: true,
    },
    uf: {
      type: 'string',
    },
    country: {
      type: 'string',
    },
  },
} as const;
